import { useCallback } from 'react';
var useCallbackOnce = function (callback) { return useCallback(callback, []); };
export default useCallbackOnce;
//# sourceMappingURL=useCallbackOnce.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/tools/dist/react/hooks/useCallbackOnce.js
// module id = 29
// module chunks = 1